export enum FileMime {
  Excel,
  Pdf,
  Ppt,
  Word,
  Other
}
